import styled from "styled-components";
import Cursor from "../../assets/images/point.png";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: grid;
  place-items: center;
  background-image: url("https://i.ytimg.com/vi/LgtRqwfJGbI/maxresdefault.jpg");
  background-size: cover;
  overflow: auto;
`;

export const FormContainer = styled.div`
  display: grid;
  place-items: center;
  animation: opacity 1s;

  @media (min-width: 800px) {
    padding: 20px;
  }

  @keyframes opacity {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 500px;
  padding: 30px 20px;
  border: 1px solid #f2eded;
  border-radius: 8px;
  font-family: "Roboto", arial;
  font-size: 20px;

  input,
  text-area {
    background-color: #c6823e;
    font-size: 30px;
    border-radius: 8px;
    border-color: red;
    height: 27px;
    padding: 30px;
  }

  div {
    margin-bottom: 5px;
  }

  button {
    color: #fff;
    font-size: 16px;
    font-family: "Press Start 2P", cursive;
    margin-top: 10px;
    padding: 10px;
    height: 60px;
  }

  p {
    color: #bdbdbd;
    text-align: center;
    max-width: 70%;
    align-self: center;
    line-height: 45px;
  }

  .sprite {
    position: initial;
    height: 300px;

    h3 {
      font-size: 19px;
    }

    ul {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      height: 200px;
      list-style: none;

      li {
        height: 90%;

        button {
          background-color: transparent;
          border: none;
          height: 100%;
        }
      }

      .selected {
        filter: drop-shadow(0 0 0.8rem crimson);
      }

      img {
        /* width: 200px; */
        height: 90%;
        transition: 0.3s;
        cursor: pointer;
        :hover {
          transform: scale(1.1);
        }

        :active {
          filter: drop-shadow(0 0 0.8rem crimson);
        }
      }
    }
  }
`;
